/*
 * @Author: yuhaiqin@wps.cn
 * @Description: 获取支付框需要参数
 */
import { apiGetPaymentConfig } from '@vas2t-lowcode/api';
import { dateCountDays } from './date-func';
export const getPayConfig = async ({ position, extra }: { position: string; extra: any }) => {
  let payconfigStr = '';
  try {
    const { data } = await apiGetPaymentConfig();
    payconfigStr = data.pure_team_mode || '';
  } catch (error) {
    // 获取支付配置失败
    console.log(error);
    return;
  }
  const payConfig = {
    isClient: false,
    // 运营/产品 提供
    from_name: 'vas2t',
    csource: payconfigStr,
    position,
    // 接口获取
    payconfig: payconfigStr,
    // 支付配置
    extra,
  };
  payConfig.extra = JSON.stringify(extra);
  return payConfig;
};

/**
 * @description: 获取 position 拼接参数
 * @return {*}
 * position 拼接规则: 使用天数 | 平台版本 | 支付位置 | 模板名称 (非轻流内嵌页无需上报)
 */
export const getPositionRule = ({
  create_time,
  member_level,
  position,
}: {
  create_time: number;
  member_level: string;
  position: string;
}) => {
  return `${dateCountDays(create_time, new Date().valueOf())}|${member_level}|${position}|`;
};
